import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

type AdminPasswordInputProps = {
  id: string;
  value: string;
  onChange: (value: string) => void;
  className: string;
  placeholder?: string;
  required?: boolean;
  autoComplete?: string;
};

/**
 * 密碼輸入欄位（含顯示/隱藏切換），供總後台各處密碼欄位共用（管理者登入、管理者帳號管理、會員密碼設定等）。
 * className 由呼叫端傳入既有的輸入框樣式，這裡只負責補上右側留白（pr-11）給切換按鈕使用。
 */
export default function AdminPasswordInput({
  id,
  value,
  onChange,
  className,
  placeholder,
  required,
  autoComplete,
}: AdminPasswordInputProps) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <input
        id={id}
        type={visible ? "text" : "password"}
        required={required}
        autoComplete={autoComplete}
        className={`${className} pr-11`}
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      <button
        aria-label={visible ? "隱藏密碼" : "顯示密碼"}
        className="absolute right-1 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-md text-[#7b877f] transition hover:bg-[#f0f5f2] hover:text-[#315746]"
        onClick={() => setVisible((current) => !current)}
        tabIndex={-1}
        type="button"
      >
        {visible ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
